(() => {
  const HANDLE = 'wholesale-best-seller-2x6-closure-bob-wigs';
  let latestVariantId = null;
  let scheduled = false;

  const money = (cents) => {
    const rands = Math.round(Number(cents || 0) / 100);
    return 'R ' + rands.toLocaleString('en-US');
  };

  // Keep the visible price in sync without triggering a MutationObserver loop.
  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  const fullMoney = (cents) =>
    'R ' + (Number(cents || 0) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

  const setPriceText = (element, value) => {
    if (!element) return;
    const textNodes = Array.from(element.childNodes).filter((node) => node.nodeType === 3);
    const visibleText = textNodes.map((node) => node.textContent).join('').trim();
    if (visibleText === value) return;
    textNodes.forEach((node) => node.remove());
    element.appendChild(document.createTextNode(value));
  };

  const getRoot = () => document.querySelector('[data-tht-wholesale-selector]');
  const getVariantDataNode = () => document.querySelector('script[data-tht-variants]');

  const getVariants = () => {
    const node = getVariantDataNode();
    if (!node) return [];

    try {
      const parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const getRecordFromThemeVariant = (themeVariant, variants) => {
    if (!themeVariant) return null;

    const id = String(themeVariant.id || '');
    if (id) {
      const byId = variants.find((variant) => String(variant.id) === id);
      if (byId) return byId;
    }

    const options = Array.isArray(themeVariant.options) ? themeVariant.options : [];
    const length = themeVariant.option1 || options[0];
    const pack = themeVariant.option2 || options[1];
    const lace = themeVariant.option3 || options[2];

    if (!length || !lace) return null;

    return variants.find((variant) =>
      variant.length === length &&
      variant.lace === lace &&
      (!pack || variant.package === pack)
    ) || null;
  };

  const getCurrentRecord = (variants) => {
    if (latestVariantId) {
      const byLatest = variants.find((variant) => String(variant.id) === String(latestVariantId));
      if (byLatest) return byLatest;
    }

    const picker = document.querySelector('variant-picker[handle="' + HANDLE + '"]');
    const pickerData = picker && picker.querySelector('script[data-variant]');

    if (pickerData) {
      try {
        const themeVariant = JSON.parse(pickerData.textContent);
        const byPicker = getRecordFromThemeVariant(themeVariant, variants);
        if (byPicker) return byPicker;
      } catch (error) {}
    }

    const urlVariant = new URL(window.location.href).searchParams.get('variant');
    if (urlVariant) {
      const byUrl = variants.find((variant) => String(variant.id) === String(urlVariant));
      if (byUrl) return byUrl;
    }

    return variants[0] || null;
  };

  const updateCard = (root, pack, variant, qty, retailSingle, selectedPack) => {
    const card = root.querySelector('[data-tht-package="' + pack + '"]');
    if (!card || !variant) return;

    card.href = window.location.pathname + '?variant=' + variant.id;
    const active = selectedPack === pack;
    card.classList.toggle('is-active', active);

    if (active) {
      card.setAttribute('aria-current', 'true');
    } else {
      card.removeAttribute('aria-current');
    }

    const each = card.querySelector('[data-tht-each]');
    setText(each, money(variant.price / qty));

    const total = card.querySelector('[data-tht-total]');
    setText(total, money(variant.price));

    const save = card.querySelector('[data-tht-save]');
    setText(save, money((retailSingle * qty) - variant.price));
  };

  // Prestige's custom package selector updates its card prices separately.
  // Also update the primary product price so length/lace/package always agree.
  const updateTopPrice = (root, variant) => {
    const productInfo = root.closest('.product-info');
    const priceList = productInfo && productInfo.querySelector('price-list.price-list--product');
    if (!priceList || !variant) return;

    const price = Number(variant.price || 0);
    const compareAt = Number(variant.compareAtPrice || 0);
    const salePrice = priceList.querySelector('sale-price');
    setPriceText(salePrice, fullMoney(price));

    let compareEl = priceList.querySelector('compare-at-price');
    if (compareAt > price) {
      if (!compareEl && salePrice) {
        compareEl = document.createElement('compare-at-price');
        compareEl.className = 'h5 text-subdued line-through';
        const accessibleLabel = document.createElement('span');
        accessibleLabel.className = 'sr-only';
        accessibleLabel.textContent = 'Regular price';
        compareEl.appendChild(accessibleLabel);
        salePrice.after(compareEl);
      }
      setPriceText(compareEl, fullMoney(compareAt));
    } else if (compareEl) {
      compareEl.remove();
    }
  };

  const sync = (preferredRecord = null) => {
    const root = getRoot();
    const variants = getVariants();
    if (!root || variants.length === 0) return;

    const current = preferredRecord || getCurrentRecord(variants);
    if (!current) return;

    latestVariantId = current.id;

    const one = variants.find((variant) =>
      variant.length === current.length &&
      variant.lace === current.lace &&
      variant.package === '1 WIG'
    );
    const three = variants.find((variant) =>
      variant.length === current.length &&
      variant.lace === current.lace &&
      variant.package === '3 WIGS'
    );
    const five = variants.find((variant) =>
      variant.length === current.length &&
      variant.lace === current.lace &&
      variant.package === '5 WIGS'
    );

    if (!one || !three || !five) return;

    const retailSingle = one.price * 2;
    const selectedPack = current.package || '1 WIG';
    const packageQty = selectedPack === '3 WIGS' ? 3 : selectedPack === '5 WIGS' ? 5 : 1;
    const selectedVariant =
      selectedPack === '3 WIGS' ? three :
      selectedPack === '5 WIGS' ? five :
      one;

    updateCard(root, '1 WIG', one, 1, retailSingle, selectedPack);
    updateCard(root, '3 WIGS', three, 3, retailSingle, selectedPack);
    updateCard(root, '5 WIGS', five, 5, retailSingle, selectedPack);

    const retailTotal = retailSingle * packageQty;
    const currentTotal = selectedVariant.price;
    const saving = retailTotal - currentTotal;

    updateTopPrice(root, selectedVariant);

    const retailEl = root.querySelector('[data-tht-summary-retail]');
    const totalEl = root.querySelector('[data-tht-summary-total]');
    const saveEl = root.querySelector('[data-tht-summary-save]');

    setText(retailEl, money(retailTotal));
    setText(totalEl, money(currentTotal));
    setText(saveEl, money(saving));
  };

  const scheduleSync = (record = null) => {
    if (record) latestVariantId = record.id;

    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      sync(record);
    });
  };

  // Prestige v7+ fires this on every variant selection. We use the event's
  // actual variant instead of reading potentially stale DOM state.
  document.addEventListener('variant:change', (event) => {
    const variants = getVariants();
    if (variants.length === 0) return;

    const record = getRecordFromThemeVariant(event.detail && event.detail.variant, variants);
    if (!record) return;

    latestVariantId = record.id;

    // Update immediately, then once more after Prestige finishes any partial rerender.
    sync(record);
    setTimeout(() => sync(record), 0);
    setTimeout(() => sync(record), 80);
  });

  // Prestige can replace the product info DOM after a selection.
  // Re-apply the latest known variant whenever the selector is reinserted.
  const main = document.getElementById('main');
  if (main) {
    const observer = new MutationObserver(() => scheduleSync());
    observer.observe(main, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', () => scheduleSync());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleSync(), { once: true });
  } else {
    scheduleSync();
  }
})();